/* GENERATED by scripts/generate-voice-samples.ts — do not edit. */
/** sha256 over all clip bytes, truncated. Appended to every sample
 *  URL so regenerated audio busts the immutable cache. */
export const VOICE_SAMPLES_VERSION = 'ed090ee563d3';
